import iii from '../assets/imgObjet/monstera.jpg'
import ampouleOff from '../assets/imgObjet/light_icon_off.png'
import ampouleOn from '../assets/imgObjet/light_icon_on.png'
import porteOn from '../assets/imgObjet/opened.png'
import porteOff from '../assets/imgObjet/closed.png'
import ventilOn from '../assets/imgObjet/blower-high.png'
import ventilOff from '../assets/imgObjet/blower-off.png'
import fenetreOn from '../assets/imgObjet/window_icon_opened.png'
import fenetreOff from '../assets/imgObjet/window_icon_closed.png'
export const imgObjt = {
    ampoule:{
        on : ampouleOn,
        off : ampouleOff
    },
    porte:{
        on : porteOn,
        off : porteOff
    },
    ventilo:{
        on : ventilOn,
        off : ventilOff
    },
    fenetre:{
        on : fenetreOn,
        off : fenetreOff
    },

}
export const objets = [
    { idArduino : '0001H5', 
        idObjet :1,
        tokenId : '123' ,
        Objet : 'ampoule',
        categorie :'commande',
        ligne :'1',
        // urlImg :iii,
        nameObjet : 'Ampoule c',
        state : true
        },
        { idArduino : 'nzita', 
        idObjet :2,
        tokenId : '123' ,
        Objet : 'ventilo',
        categorie :'commande',
        ligne :'1',
        // urlImg :iii,
        nameObjet : 'ventillateur',
        state : false
            },
        { idArduino : 'nzita', 
        idObjet :3,
        tokenId : '123' ,
        Objet : 'ampoule',
        categorie :'commande',
        ligne :'1',
        // urlImg :iii,
        nameObjet : 'Ampoule Salon',
        state : false
            },
        { idArduino : 'nzita', 
        idObjet :4,
        tokenId : '123' ,
        Objet : 'porte',
        categorie :'commande',
        ligne :'1',
        // urlImg :iii,
        nameObjet : 'Porte central',
        state : false
        },
        { idArduino : 'nzita', 
        idObjet :5,
        tokenId : '123' ,
        Objet : 'fenetre',
        categorie :'Controler',
        ligne :'1',
        // urlImg :iii,
        nameObjet : 'Fenetre Chambre',
        state : false
        }
]